import { useMediaQuery } from "@react-hook/media-query";

interface ImageCardProps {
  image: string;
  title: string;
}

export function ImageCard({ image, title }: ImageCardProps) {
  const IS_MOBILE_VIEW = useMediaQuery("(max-width: 1000px)");
  return (
    !IS_MOBILE_VIEW ?
      <div
        className="flex items-end p-4 md:p-5 w-full h-[200px] md:h-[300px] lg:h-[380px] shadow-lg rounded-xl"
        style={{
          background: `url(${image}) center / cover no-repeat`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundBlendMode: "normal, luminosity",
        }}
      >
        <h3 className="font-poppins font-semibold text-neutral-light-50">
          {title}
        </h3>
      </div>
      :
      <h3 className="inline py-6 font-poppins font-semibold text-neutral-light-50">
        {title}
      </h3>
  );
}